import React from 'react';
import { ScanLabelConnectorApollo, withMobileAppMode } from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerScanLabelContainer from './TrackerScanLabelContainer';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';
import { hasAnyPaidAccess } from '../helpers';

const TrackerScanLabelPage: React.FC<{ mobileAppMode: boolean }> = ({ mobileAppMode }) => {
  const location = useLocation();

  // Any paid access opens the scanner, matching ScanLabelResolver's `hasAnyAccess()` guard — it is
  // not an AI-plan-only feature. Gating on `aiAccess` alone used to send diet-only subscribers to
  // the paywall for a scan the backend would have served.
  //
  // An earlier revision let the add-product form through regardless of access, to avoid a dead end
  // where the form's own "Scan label" button led to the paywall and lost the typed values. Now that
  // the backend refuses the mutation, that bypass would only trade the dead end for a failure after
  // both photos were taken — so the form's gated button routes here to show the access screen with
  // a back button instead (see TrackerAddUserProductContainer).
  const fromAddProductForm = Boolean(
    (location.state as { formValues?: unknown } | null)?.formValues
  );

  if (hasAnyPaidAccess() || mobileAppMode) {
    return (
      <ScanLabelConnectorApollo>
        {({ cancelScanLabel }) => (
          <TrackerScanLabelContainer key={location.key} cancelScanLabel={cancelScanLabel} />
        )}
      </ScanLabelConnectorApollo>
    );
  }

  // Coming from the form, the form is still behind us in the history stack with the user's typed-in
  // values, so offer a way back to it. From the action sheet there is nothing to return to.
  return <TrackerNoAccess showBackBtn={fromAddProductForm} />;
};

export default withMobileAppMode(TrackerScanLabelPage);
